import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const fadeUp = {
  hidden: { opacity: 0, y: 50 },
  visible: (delay = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay },
  }),
};

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-blue-100 via-white to-sky-100 text-gray-900 py-10 md:py-20">
      <div className="container mx-auto px-4 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">

          {/* Company Info */}
          <motion.div
            className="flex flex-col items-start"
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            custom={0}
          >
            <img
              src="/assets/logo_footer.png"
              alt="Gururkul ERP Logo"
              className="w-[170px] h-[170px] mb-3 rounded-lg"
            />
            <p className="italic text-blue-600 mb-2">(Digitize your school)</p>
            <p className="text-lg mb-4 leading-relaxed text-gray-700 text-left">
              Gururkul ERP is a leading educational management platform providing seamless
              solutions for students, teachers, and administrators.
            </p>
          </motion.div>

          {/* Product */}
          <motion.div
            className="text-left"
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            custom={0.1}
          >
            <h3 className="text-2xl font-semibold mb-4 text-gray-800">Product</h3>
            <ul>
              <li className="mb-4 hover:underline hover:text-blue-600 transition text-lg">
                <Link to="/admin-panel">Admin Panel</Link>
              </li>
              <li className="mb-4 hover:underline hover:text-blue-600 transition text-lg">
                <Link to="/student-panel">Student Panel</Link>
              </li>
              <li className="mb-4 hover:underline hover:text-blue-600 transition text-lg">
                <Link to="/teacher-panel">Teacher Panel</Link>
              </li>
              <li className="mb-4 hover:underline hover:text-blue-600 transition text-lg">
                <Link to="/library-panel">Library Panel</Link>
              </li>
              <li className="mb-4 hover:underline hover:text-blue-600 text-lg">
               <Link to="/mobile-app">Mobile App</Link>
               </li>
            </ul>
          </motion.div>

          {/* Useful Links */}
          <motion.div
            className="text-left"
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            custom={0.2}
          >
            <h3 className="text-2xl font-semibold mb-4 text-gray-800">Useful Links</h3>
            <ul>
              <li className="mb-4 hover:underline hover:text-blue-600 text-lg">
                <Link to="/about">About</Link>
              </li>
              <li className="mb-4 hover:underline hover:text-blue-600 text-lg">
                <Link to="/contact">Contact Us</Link>
              </li>
              <li className="mb-4 hover:underline hover:text-blue-600 text-lg">
                <Link to="/marketing-partner">Marketing Partner</Link>
              </li>
              <li className="mb-4 hover:underline hover:text-blue-600 text-lg">
                <Link to="/terms-conditions">Terms & Conditions</Link>
              </li>
              <li className="mb-4 hover:underline hover:text-blue-600 text-lg">
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
               <li className="mb-4 hover:underline hover:text-blue-600 text-lg">
               <Link to="/blogs">Blogs</Link>
               </li>
                <li className="mb-4 hover:underline hover:text-blue-600 text-lg">
               <Link to="/sitemap">Sitemap</Link>
               </li>

            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            className="text-left"
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            custom={0.3}
          >
            <h3 className="text-2xl font-semibold mb-4 text-gray-800">Contact Info</h3>
            <p className="mb-4 flex items-center text-lg">
              <FaMapMarkerAlt className="mr-2 text-blue-600" />
              Old Sabzi Mandi, Sirsa, Haryana
            </p>
            <p className="mb-4 flex items-center text-lg">
              <FaPhone className="mr-2 text-blue-600" />
              <a href="tel:+918295000455" className="hover:text-blue-600 hover:underline">
                8295000455
              </a>
            </p>
            <p className="mb-4 flex items-center text-lg">
              <FaEnvelope className="mr-2 text-blue-600" />
              <a
                href="mailto:info@gururkulerp.in"
                className="hover:text-blue-600 hover:underline"
              >
                info@gururkulerp.in
              </a>
            </p>
            
          </motion.div>
        </div>

        <hr className="my-8 border-gray-300" />

        <motion.div
          className="text-center mt-4"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <p className="text-lg text-gray-700">
            &copy; 2019 Shri Satya Technologies. All rights reserved.
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
